const ColumnsList: any[] = [
  {
    title: "Mã",
    dataIndex: "id",
    key: "id",
    show: true,
    align: "left",
  },
  {
    title: "Mã kho",
    dataIndex: "code",
    key: "code",
    show: true,
    align: "left",
  },
  {
    title: "Tên kho",
    dataIndex: "name",
    key: "name",
    show: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    key: "description",
    show: true,
    align: "left",
  },
  {
    title: "Vị trí",
    dataIndex: "viTri",
    key: "viTri",
    show: true,
    align: "left",
    width: 180,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    width: 80,
  },
];

export {ColumnsList};
